var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigateArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 7,
    viewBox: "0 0 6 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.25293C0.223858 0.25293 7.45058e-09 0.476787 7.45058e-09 0.75293C7.45058e-09 1.02907 0.223858 1.25293 0.5 1.25293H4.29289L0.146447 5.39938C-0.0488155 5.59464 -0.0488155 5.91122 0.146447 6.10648C0.341709 6.30174 0.658291 6.30174 0.853553 6.10648L5 1.96004V5.75293C5 6.02907 5.22386 6.25293 5.5 6.25293C5.77614 6.25293 6 6.02907 6 5.75293V0.75293C6 0.476787 5.77614 0.25293 5.5 0.25293H0.5Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateArrow);
export default __webpack_public_path__ + "static/media/navigate-arrow.3799811c5b5cd3a4c493f363853ca0ff.svg";
export { ForwardRef as ReactComponent };